module.exports = __webpack_public_path__ + "img/homepage_logo.6421e3c3.png";